import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyConfigurationPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfigurationContainer" */ '../src/Configuration/ConfigurationPage.tsx'
			)
		).ConfigurationPage,
});
